import React from 'react';
import './Footer.scss';
import { useLocation } from 'react-router-dom';
import { ReactComponent as SSFullLogo } from 'assets/icons/SSFullLogo.svg';
import { ReactComponent as SutLogo } from 'assets/icons/sutLogo.svg';
import { ReactComponent as SSFooterLogo } from 'assets/icons/SSFooterLogo.svg';
import { ReactComponent as FooterGraphic } from 'assets/icons/redesign/footer-graphic.svg';

const LINKS = [
    {
        label: 'На сайте СПбГУТ',
        url: 'https://www.sut.ru/studentu/studencheskiy-sovet',
    },
    { label: 'Вконтакте', url: 'https://vk.com/studsovet.bonch' },
    { label: 'InGUT — Студенческие новости', url: 'https://vk.com/ingut' },
];

function LegacyFooter(): React.ReactElement {
    return (
        <footer className="legacy-footer card-3">
            <div className="background-logo">
                <SSFooterLogo />
            </div>
            <SSFullLogo />
            <p>
                © 2005 — 2026 <br />
                Студенческий совет СПбГУТ <br />
                Designed by{' '}
                <a target="_blank" href="https://brsv.design" rel="noreferrer">
                    Alexander Borisov
                </a>
                , powered by{' '}
                <a target="_blank" href="https://crysto.ru" rel="noreferrer">
                    Crysto
                </a>
                .
            </p>
            <div className="menus">
                <div className="footer-menu">
                    <div className="footer-menu_header">
                        Студенческий совет СПбГУТ
                    </div>
                    {LINKS.map(link => (
                        <a key={link.url} href={link.url}>
                            {link.label}
                        </a>
                    ))}
                </div>
            </div>
            <a
                className="sut-logo"
                href="https://www.sut.ru"
                target="_blank"
                rel="noreferrer"
            >
                <SutLogo />
            </a>
        </footer>
    );
}

/**
 * Подвал по макету: тёмная карточка, логотип и копирайт слева, ссылки
 * студсовета в середине, лого СПбГУТ и большая графика справа.
 *
 * Под `/admin/**` остаётся прежняя вёрстка — редизайн админки в декабре.
 */
function Footer(): React.ReactElement {
    const { pathname } = useLocation();
    if (pathname.indexOf('/admin') === 0) return <LegacyFooter />;

    return (
        <div className="rd-container">
            <footer className="rd-footer">
                <span className="rd-footer__graphic" aria-hidden="true">
                    <FooterGraphic />
                </span>
                <div className="rd-footer__left">
                    <span className="rd-footer__logo">
                        <SSFullLogo />
                    </span>
                    <div className="rd-footer__meta">
                        <span>© 2005 — 2026</span>
                        <span>Студенческий совет СПбГУТ</span>
                        <span>
                            Designed by{' '}
                            <a
                                href="https://brsv.design"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Alexander Borisov
                            </a>
                            , powered by{' '}
                            <a
                                href="https://crysto.ru"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Crysto.
                            </a>
                        </span>
                    </div>
                </div>
                <nav className="rd-footer__menu">
                    <p className="rd-footer__menuHead">
                        Студенческий совет СПбГУТ
                    </p>
                    <div className="rd-footer__links">
                        {LINKS.map(link => (
                            <a
                                key={link.url}
                                href={link.url}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {link.label}
                            </a>
                        ))}
                    </div>
                </nav>
                <a
                    className="rd-footer__sut"
                    href="https://www.sut.ru"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Сайт СПбГУТ"
                >
                    <SutLogo />
                </a>
            </footer>
        </div>
    );
}

export default React.memo(Footer);
